import { render } from "./Parallax.vue?vue&type=template&id=3c557c46&scoped=true"
import script from "./Parallax.vue?vue&type=script&lang=ts"
export * from "./Parallax.vue?vue&type=script&lang=ts"

import "./Parallax.vue?vue&type=style&index=0&id=3c557c46&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3c557c46"

export default script